import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { useApp } from "@/context/AppContext";

const Section = ({ id, title, text }) => (
  <section id={id} data-testid={`legal-section-${id}`} className="sb-card p-5 scroll-mt-4">
    <h2 className="text-lg font-heading font-semibold text-gray-900 mb-2">{title}</h2>
    <p className="font-body text-gray-700 whitespace-pre-line leading-relaxed text-sm">{text}</p>
  </section>
);

export default function Legal() {
  const { t } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    const id = window.location.hash.replace("#", "");
    if (id) {
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    }
  }, []);

  return (
    <div className="mx-auto max-w-md min-h-[100dvh] px-6 py-8 sm:border-x-2 sm:border-gray-800 space-y-4" style={{ background: "var(--app-bg)" }} data-testid="legal-page">
      <button data-testid="legal-back" onClick={() => navigate(-1)} className="flex items-center gap-1 font-heading text-gray-600"><ArrowLeft size={20} weight="bold" />{t("back")}</button>
      <div className="flex flex-col items-center mb-2"><Logo className="h-14" /></div>
      <h1 className="text-2xl font-heading font-semibold text-gray-900">{t("legalTitle")}</h1>
      <Section id="privacy" title={t("privacy")} text={t("privacyText")} />
      <Section id="imprint" title={t("imprint")} text={t("imprintText")} />
      <Section id="policies" title={t("policies")} text={t("policiesText")} />
    </div>
  );
}
